<template>
<div class="login-container">
    
    <!-- <p>Verify a certificate</p><br> -->
    <div v-if="isMobile()">
<div  class="card" >
        <div class="card-content">
            <img src="/static/lu_logo.png" alt="Logo" width="150">
            <!-- <div class="title is-size-3 has-text-left">Hello,</div> -->
            <!-- <div class="title is-size-4 has-text-left" style="margin-top:7%">Verify Certificate</div> -->
            <b-field type="is-primary" style="margin-top:10%" label="Verify Certificate">
                <b-input type="search" size="is-medium"  placeholder="Enter Certificate No." v-model="certificateNo"></b-input>
            </b-field>
            
           <!--  <p class="has-text-danger">{{error}}</p> -->
                <router-link  tag="b-button" style="width=100%; " v-bind:to="{ name: 'Verify', params: { certificateNo: certificateNo  }}" ><strong>VALIDATE</strong></router-link>
            <!-- <b-button style="margin-top:5%"  type="is-primary" expanded :class="{'is-loading': isLoading}" @click="login"> <strong>VALIDATE</strong> </b-button> -->

            <div class="subtitle has-text-centered is-size-7" style="margin-top:10px">
                <b>2020 © LetsUpgrade</b>
            </div>

            <!-- <center style="padding-top:5px; color:black">
                            <router-link class="has-text-weight-bold	is-size-7" style="color:black;" to="/forgot">Forgot your password ?</router-link>
                        </center> -->

        </div>

    </div>
    </div>
    <div v-else class="card" style="width:30%">
        <div class="card-content">
            <img src="/static/lu_logo.png" alt="Logo" width="200">
            <!-- <div class="title is-size-3 has-text-left">Hello,</div> -->
            <!-- <div class="title is-size-4 has-text-left" style="margin-top:7%">Verify Certificate</div> -->
            <b-field type="is-primary" style="margin-top:10%" label="Verify Certificate">
                <b-input type="search" size="is-medium"  placeholder="Enter Certificate No." v-model="certificateNo"></b-input>
            </b-field>
            
           <!--  <p class="has-text-danger">{{error}}</p> -->
                <router-link  tag="b-button" style="width=100%; " v-bind:to="{ name: 'Verify', params: { certificateNo: certificateNo  }}" ><strong>VALIDATE</strong></router-link>
            <!-- <b-button style="margin-top:5%"  type="is-primary" expanded :class="{'is-loading': isLoading}" @click="login"> <strong>VALIDATE</strong> </b-button> -->

            <div class="subtitle has-text-centered is-size-7" style="margin-top:10px">
                <b>2020 © LetsUpgrade</b>
            </div>

            <!-- <center style="padding-top:5px; color:black">
                            <router-link class="has-text-weight-bold	is-size-7" style="color:black;" to="/forgot">Forgot your password ?</router-link>
                        </center> -->

        </div>

    </div>

</div>
</template>

<script>
import Firebase from '../../lib/Firebase';
import Firestore from "../../lib/Firestore";
import dashboardService from './service.js'
import Vue2Filters from 'vue2-filters';

export default {
    name: "dashboard",
    mixins: [Vue2Filters.mixin],
    components: {

    },
    data() {
        return {

            certificateNo : ''
        }
    },
    computed: {

    },
    created() {
       
 
    },
    mounted() {
        // console.log(this.finishBtn)
    },
    computed() {
        //  console.log(this.finishBtn)
    },
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
       

    }
}
</script>

<style scoped>
.login-container {
    background-color: #ffffff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.button{
    width: 100%;
    color : #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/Dashboard.vue